<script>
    import PriceCard from "../components/PriceCard.svelte";
    import PageTransition from "../components/PageTransition.svelte";

    import { onMount } from "svelte";

    onMount(() => {
    window.scrollTo(0, 0);
    });
</script>
<head>
    <link rel="canonical" href="https://fyrehost.net/factorio" />
    <link rel='stylesheet' href='global.css'>
	<link rel='stylesheet' href='build/bundle.css'>
    <style>
        html {
            scroll-behavior: smooth;
        }
        
        /* width */
        ::-webkit-scrollbar {
            width: 10px;
        }

        /* Track */
        ::-webkit-scrollbar-track {
            background: #3B375E;
            /*border-radius: 10px;*/
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
            background: #68638D;
            border-radius: 10px;
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
            background: #9992BF;
        }
    
    </style>
    <meta name="description" content="Cheap and Fast Factorio Server Hosting with Unlimited Slots and Lifetime Pricing!">
</head>
<div>

</div>
<PageTransition>

    <PriceCard 
    name="Factorio" 
    price="1"
    cpu="2 vCores" 
    ram="1GB DDR4 RAM" 
    paymentLink="https://buy.stripe.com/bIY4i54Wd2t93zW4gu" 
    paymentLinkDE="https://buy.stripe.com/28ocOB0FXd7NfiE4gL"
    paymentLinkUSE="https://buy.stripe.com/00gg0NfAR3xd8Ug28K"
    paypalLink="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-80W26804DK7552046MFLGV3Y"
    paypalLinkDE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-4F373885M4318060KMGNOJSA"
    paypalLinkUSE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-7SY73978XC6452354MG7JHTI"
    name2="Factorio"
    price2="2"
    cpu2="2 vCores"
    ram2="2 GB DDR4 RAM"
    paypalLink2="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-70516448XC961890RMFLGW5A"
    paypalLink2DE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-2BH4503941544170VMGNOKEA"
    paypalLink2USE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-4TB97055WE336745WMG7JHLI"
    paymentLink2="https://buy.stripe.com/28o6qd4Wd4BheeAdR5"
    paymentLink2DE="https://buy.stripe.com/6oEbKxgEVgjZgmI28E"
    paymentLink2USE="https://buy.stripe.com/aEU15T1K19VBdawcNn"
    name3="Factorio"
    price3="3"
    cpu3="2 vCores"
    ram3="3GB DDR4 RAM"
    paypalLink3="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-4SF60404NK2531153MFLGXYY"
    paypalLink3DE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-4X812825MA511752CMGNOKJI"
    paypalLink3USE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-3R344299CA8408249MG7JFAA"
    paymentLink3="https://buy.stripe.com/cN24i50FX0l1gmIbIY"
    paymentLink3DE="https://buy.stripe.com/9AQ5m960h1p59Yk00x"
    paymentLink3USE="https://buy.stripe.com/00g5m99ct1p53zW6oY"
    name4="Factorio"
    price4="4"
    cpu4="2 vCores"
    ram4="4GB DDR4 RAM"
    paypalLink4="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-3HA86490K1732760GMFLG2MQ"
    paypalLink4DE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-3FE62082YF5406803MGNOKPA"
    paypalLink4USE="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-92173007T7715123VMG7JESI"
    paymentLink4="https://buy.stripe.com/aEU5m99ctffVb2o8wN"
    paymentLink4DE="https://buy.stripe.com/00g3e10FX1p5fiE5kS"
    paymentLink4USE="https://buy.stripe.com/5kA5m91K12t9b2odRp"

    location="FI"
     ></PriceCard>
</PageTransition>
